export function inScrollableParent(node: HTMLElement | null): boolean {
  if (!node) return false;

  let current: HTMLElement | null = node;

  // check parents
  while (current && current !== document.body) {
    if (current.scrollHeight > current.clientHeight) {
      return true;
    }

    current = current.parentElement;
  }

  // check documentElement and body
  const docEl = document.documentElement;
  const body = document.body;
  if (docEl && docEl.scrollHeight > docEl.clientHeight) {
    return true;
  }
  if (body && body.scrollHeight > body.clientHeight) {
    return true;
  }

  return false;
}
